import { render } from "./province-create-import.vue?vue&type=template&id=a9eec53a"
import script from "./province-create-import.vue?vue&type=script&lang=js"
export * from "./province-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__